export const seoOptimise = true
export const resolveAliases = false
export const titleTemplate = "%pageTitle %titleSeparator %siteName"
export const ogTitleTemplate = "%pageTitle %titleSeparator %siteName"
export const ogDescriptionTemplate = "%s"